module.exports = __webpack_public_path__ + "3b10d7439e47661a9eac3d53c25bef82.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/airbnb_2022_chart.png
// module id = 1628
// module chunks = 0